<script setup lang="ts">
import {
  LineRichMenuFormActionTypeLink,
  LineRichMenuFormActionTypeText,
  LineRichMenuFormActionTypeUnselected,
  type LineRichMenuFormErrorManager,
  type LineRichMenuFormTemplateActionType,
} from './formSchema'
import AppAccordion from '@/components/molecules/AppAccordion.vue'
import DolphinSelector from '@/components/atoms/DolphinSelector.vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import LineRichMenuFormErrorMessage from './LineRichMenuFormErrorMessage.vue'

const model = defineModel<LineRichMenuFormTemplateActionType[]>({
  required: true,
})

const props = defineProps<{
  formErrorManager: LineRichMenuFormErrorManager
}>()

const actionTypeOptions = [
  {
    text: '選択してください',
    value: LineRichMenuFormActionTypeUnselected,
  },
  {
    text: 'リンク',
    value: LineRichMenuFormActionTypeLink,
  },
  {
    text: 'テキスト',
    value: LineRichMenuFormActionTypeText,
  },
]
</script>
<template>
  <section>
    <div :class="$style.item">
      <p :class="$style.sectionTitle">タイルごとのアクション</p>
      <LineRichMenuFormErrorMessage
        :errorMessage="props.formErrorManager.get(`templateActions`)"
      />
    </div>
    <div
      v-if="model.length > 0"
      :class="[$style.section__contents, $style.actions]"
    >
      <AppAccordion
        :class="$style.actions__item"
        v-for="(templateAction, index) in model"
        :key="templateAction.panelName"
      >
        <template #title>
          <p>{{ templateAction.panelName }}</p>
        </template>
        <template #content>
          <p :class="$style.type">タイプ</p>
          <DolphinSelector
            v-model="templateAction.actionType"
            :options="actionTypeOptions"
            :ellipsis="true"
            :class="$style.selector"
          />
          <LineRichMenuFormErrorMessage
            :errorMessage="
              props.formErrorManager.get(`templateActions.${index}.actionType`)
            "
          />
          <div
            v-if="templateAction.actionType === LineRichMenuFormActionTypeLink"
          >
            <p :class="$style.type">URL を入力</p>
            <DolphinTextInput
              v-model="templateAction.url"
              :class="$style.textInput"
            />
            <LineRichMenuFormErrorMessage
              :errorMessage="
                props.formErrorManager.get(`templateActions.${index}.url`)
              "
            />
            <p :class="$style.type">アクションラベルを入力</p>
            <DolphinTextInput
              v-model="templateAction.label"
              :class="$style.textInput"
            />
            <LineRichMenuFormErrorMessage
              :errorMessage="
                props.formErrorManager.get(`templateActions.${index}.label`)
              "
            />
          </div>
          <div
            v-if="templateAction.actionType === LineRichMenuFormActionTypeText"
          >
            <p :class="$style.type">テキストを入力</p>
            <DolphinTextInput
              v-model="templateAction.text"
              :class="$style.textInput"
            />
            <LineRichMenuFormErrorMessage
              :errorMessage="
                props.formErrorManager.get(`templateActions.${index}.text`)
              "
            />
          </div>
        </template>
      </AppAccordion>
    </div>
  </section>
</template>

<style lang="scss" module>
.sectionTitle {
  font-size: 18px;
  font-weight: bold;
}

.actions {
  margin-top: 16px;

  &__item {
    border-radius: 8px;
    border: 1px solid $color-border-medium-emphasis;

    &:nth-child(n + 2) {
      margin-top: 20px;
    }
  }
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.selector {
  width: 100%;
  margin-top: 10px;
}

.type {
  font-size: 16px;
  margin-top: 24px;
}

.textInput {
  width: 100%;
  margin-top: 10px;
}
</style>
